/*
 * Copyright (c) 2023 Bolmate B.V.
 */

import './settings';
import * as Sentry from '@sentry/react';

import {polyfill} from 'seamless-scroll-polyfill';

import {getSetting} from '@dvrd/dvr-controls';

import {setDeviceId} from './utils';

import '../i18n';

declare global {
    // `log`, `settings`, `allowCookies`, `gtag` are already declared by
    // @dvrd/dvr-controls/src/js/util/miscUtil.ts via its own `declare global`;
    // re-declaring `log` / `gtag` here with a different type breaks interface
    // merging (TS2717). Properties below are bolmate-specific additions.
    interface Window {
        mode: string;
        modeSettings: {[index: string]: any};
        dataLayer: any;
        onSignInGoogle: (googleUser: unknown) => void;
        unlayer: any;
        Beacon: (method: string, ...args: unknown[]) => void;
        Chart: any;
        version: string;
    }
}

const sentryUrl = getSetting('sentryUrl');
if (sentryUrl?.length) {
    const version = `bolmate@${window.version}`;
    Sentry.init({
        dsn: sentryUrl,
        release: version,
        ignoreErrors: [
            'Error: ResizeObserver loop completed with undelivered notifications.',
            'AbortError: Fetch is aborted',
            'TypeError: Failed to fetch'
        ]
    });
}

setDeviceId();
polyfill();
